import { GridBaseDataProvider } from '../../../grid/GridBaseDataProvider';
import {
  Column,
  ColumnKeys,
  DEFAULT_PAGE_NUMBER,
  DEFAULT_PAGE_SIZE,
  EasmArtifactsInventoryGridResponse,
} from '../types';
import {
  GetRowsRequest,
  GetSummaryRequest,
  GetSummaryResponse,
  SetFiltersRequest,
  UpdateSettingsRequest,
  UpdateSettingsResponse,
} from '../../../grid/types/common';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';
import { convertGridFiltersToExtJsFilters } from '../../../grid/utils/filters';
import { sanitizeObject } from '../../../utils/sanitization.utils';
import { translateFn } from '../../../utils/translator.helper';
import { API_TYPE_EASM } from '../../../webcomponents.constants';
import { FindingClassType } from '../../types';

export class EasmArtifactsInventoryGridDataProvider extends GridBaseDataProvider<Column, ColumnKeys> {
  public companyFilterDataProvider = API_TYPE_EASM;
  private response: EasmArtifactsInventoryGridResponse | null = null;

  public async getSummary(request: GetSummaryRequest<ColumnKeys>): Promise<GetSummaryResponse> {
    this.response = await ConsoleRequest.createRequest<EasmArtifactsInventoryGridResponse>({
      dataProviderType: DataProviderType.CORE,
      endpoint: 'EASMFindings',
      method: 'getEASMFindings',
      payload: {
        findingClass: FindingClassType.ARTIFACT,
        page: request.pageNumber ?? DEFAULT_PAGE_NUMBER,
        limit: request.pageSize ?? DEFAULT_PAGE_SIZE,
        sort: request.sortColumnName ?? null,
        dir: request.sortDirection ?? null,
        filters: convertGridFiltersToExtJsFilters(request.filters),
      },
    });

    return sanitizeObject({
      summary: translateFn('{itemsCount} items', { itemsCount: this.response.total }),
      numItems: this.response.total,
    });
  }

  public async getRows(request: GetRowsRequest<Column, ColumnKeys>): Promise<any> {
    return sanitizeObject({ rawEvents: (this.response as EasmArtifactsInventoryGridResponse).data });
  }

  public async updateSettings(params: UpdateSettingsRequest<Column>): Promise<UpdateSettingsResponse> {
    return {};
  }

  public async setFilters(request: SetFiltersRequest<ColumnKeys>): Promise<{} | undefined> {
    return undefined;
  }

  public getResponse(): EasmArtifactsInventoryGridResponse | null {
    return this.response;
  }
}
